const pic_01 = require("@/assets/images/mechanis/01_zongbu.png")
const pic_02 = require("@/assets/images/mechanis/02_zhonghuanengyuan.png")
const pic_03 = require("@/assets/images/mechanis/pic_03.png")
const pic_04 = require("@/assets/images/mechanis/pic_04.png")
const pic_05 = require("@/assets/images/mechanis/pic_05.png")
const pic_06 = require("@/assets/images/mechanis/06_zhongguohaohua.png")
const pic_07 = require("@/assets/images/mechanis/pic_07.jpg")
const pic_08 = require("@/assets/images/mechanis/08_cangzhoudahua.png")
const pic_09 = require("@/assets/images/mechanis/09_huagongxiangjiao.png")
const pic_10 = require("@/assets/images/mechanis/pic_10.jpg")
const pic_11 = require("@/assets/images/mechanis/pic_11.jpg")
const pic_12 = require("@/assets/images/mechanis/pic_12.png")
const pic_13 = require("@/assets/images/mechanis/pic_13.png")
const pic_14 = require("@/assets/images/mechanis/pic_14.png")
const pic_15 = require("@/assets/images/mechanis/15_hangjituan.png")
const pic_16 = require("@/assets/images/mechanis/pic_16.png")
const pic_17 = require("@/assets/images/mechanis/pic_17.png")
const pic_18 = require("@/assets/images/mechanis/18_zhonghuacaiwu.png")
const pic_19 = require("@/assets/images/mechanis/pic_19.jpg")
const pic_20 = require("@/assets/images/mechanis/pic_20.png")
const pic_21 = require("@/assets/images/mechanis/pic_21.png")
const domain = 'https://wecruit.hotjob.cn'
const suiteKey = 'SU611a641a0dcad4106f04950e'

export const mechanisList = [
    {
        title: '中国中化控股有限责任公司',
        img_url: pic_01,
        isActive: true,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F3`,
        content: '中国中化控股有限责任公司（简称中国中化，英文简称Sinochem Holdings）是由中国中化集团有限公司与中国化工集团有限公司联合重组而成，于2021年5月8日正式揭牌成立，为国务院国资委监管的国有重要骨干企业。业务范围覆盖生命科学、材料科学、石油化工、环境科学、橡胶轮胎、机械装备、城市运营、产业金融等八大领域。中国中化坚持“世界一流综合性化工企业”的战略定位，瞄准助力农业高质量发展、助推化工新材料补短板的重大战略需求，承担央企产业使命，创建全球领先的农业科技公司和世界一流的化工新材料公司；实施由单一产品向产业链升级，由提供产品向提供综合解决方案升级，由传统企业向数字化、智能化的企业升级。'
    },
    {
        title: '中化能源股份有限公司',
        img_url: pic_02,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F4`,
        content: '中化能源是一家科技驱动、创新成长、卓越管理的石油石化产业运营商及综合服务商。公司通过扩展炼化产业链、垂直延伸产品链，提升核心资产竞争实力；持续扩大石化产品经销网络及仓储物流网络的规模，为内外部客户提供综合服务。公司通过自主研发的基于互联网技术的全新石油石化产品经营平台，切实地拥抱数字化浪潮，持续实现产业数字化升级。中化能源致力于成为中国能源化工行业高质量、可持续发展的践行者。'

    },
    {
        title: '先正达集团中国',
        img_url: pic_03,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F7`,
        content: '先正达集团中国是中国领先的农业科技全球化企业，是先正达集团旗下四大业务单元之一。公司业务覆盖种子、植保、作物营养、现代农业服务与数字农业以及粮食等业务领域。公司秉持“让现代农业惠及更多农民和消费者”的使命，致力于成为 “最具创新力的中国农业科技全球化公司”。依托强大的科技创新能力和全产业链协同优势，公司通过“良种”、“良田”、“良品”、“良法”为中国农业现代化贡献解决方案，聚焦作物单产提升和产品品质改善，助力农业提质增效、农户增产增收，加快推动中国农业转型和绿色发展。'

    },
    {
        title: '化工事业部',
        img_url: pic_04,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F8`,
        content: '化工事业部是中国中化材料科学核心主业的承担者，在高性能材料及中间体、聚合物添加剂、医药健康等领域具有核心竞争力，是中国领先的化工新材料产品综合服务商，客户遍及全球100多个国家和地区。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;化工事业部以“精细化学 绿色生活”为愿景，持续聚焦化工新材料核心主业，以产业链思维和一体化产业布局进行战略转型，聚焦环氧树脂、聚合物添加剂、工程塑料、芳纶等核心产业链，打造技术领先、具有核心竞争力的新材料产业集群，致力于成为世界级的材料科学平台。'

    },
    {
        title: '中国蓝星（集团）股份有限公司',
        img_url: pic_05,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1294`,
        content: '中国蓝星（集团）股份有限公司是中国中化控股有限责任公司旗下全球领先的化工材料和特种化学品公司，目前在全球拥有53个主要生产基地，2家海外企业，24所科研机构，超过12000名员工，海外企业员工人数超过10000名。今天的蓝星公司，通过建设国际化管理团队，引进全球最佳实践，推动管理和业务变革，构建了战略定位清晰、主营业务突出的产业结构。未来的蓝星公司将更加专注于可持续发展业务，通过不断的技术创新，以更加安全、环保的产品和服务满足用户需要，帮助人类创造美好新生活。'

    },
    {
        title: '中国昊华化工集团股份有限公司',
        img_url: pic_06,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F769`,
        content: '中国昊华是在原化工部党组关怀下经国务院批准设立的国有大型化工企业，控股上市公司昊华科技，为中国中化专业公司之一。主要以高端氟材料、电子化学品、航空化工材料和碳减排业务为核心产业板块，建有国家级工程中心、国家重点实验室等各类科技创新平台124个， “十四五”以来，荣获各级各类科技奖励100余项。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司秉持“科学至上”核心发展理念，坚持“科技引领，创新驱动，追求卓越”，致力于成为中国先进化工材料引领者，促进人类生活品质提高与技术进步。'

    },
    {
        title: '鲁西集团有限公司',
        img_url: pic_07,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1362`,
        content: '鲁西集团是国有控股企业，于1976年建成，2020年加入中国中化控股有限责任公司（简称中国中化），职工12000余人。涵盖煤化工、盐化工、氟化工、硅化工、化工新材料等，年产化工产品1000万吨，产品除国内销售外，还远销欧美及东南亚等国家和地区，各种产品市场用途广泛，发展前景广阔。主要生产聚碳酸酯、己内酰胺、尼龙6、双氧水、多元醇、甲酸、高端新型制冷剂、有机硅、甲烷氯化物、烧碱、甲醇等百余类产品，目前总资产353亿元。 '

    },
    {
        title: '沧州大化集团有限责任公司',
        img_url: pic_08,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1018`,
        content: '沧州大化集团有限责任公司是中国中化控股有限责任公司旗下二级公司，始建于1973年，2000年成功上市，股票代码600230。公司坐落于美丽的渤海之滨-河北沧州，现有16万吨TDI、10万吨PC、20万吨双酚A、16万吨离子膜烧碱、13.5万吨硝酸、1.2万吨/年人造革的生产能力。荣获全国五一劳动奖状、全国先进基层党组织、全国十大管理模式创新领先企业、聚氨酯产业领军企业、全国石油和化学工业环境保护先进单位、全国石油和化工行业两化融合优秀实践奖、中国化工行业卓越品牌、国家863计划CIMS应用示范企业。'
    },
    {
        title: '氯碱事业部',
        img_url: pic_12,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F772`,
        content: '中国中化氯碱事业部成立于2022年11月，是中国中化核心战略实施平台之一，业务范围涉及氯碱化工、无机粉体、石油化工、原料药等领域，主要产品有通用树脂、糊树脂、聚醚多元醇等。拥有沈阳化工、德州实华等9家直属企业。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;事业部拥有先进的生产基地、研发设施及完善的营销体系，是国内最大的烧碱和PVC树脂生产商之一，总体规模均居于全国第二，其中PVC糊树脂产能亚洲第一；聚醚多元醇是聚醚行业唯一“知名品牌”企业、行业唯一市场价格标杆企业；氯丁橡胶是国内仅有的两家氯丁橡胶生产商之一，占国内总产能的50%。'

    },
    {
        title: '中国化工橡胶有限公司',
        img_url: pic_09,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F771`,
        content: '中国中化旗下拥有全球领先轮胎和橡胶品制造商——中国化工橡胶有限公司，公司在全球13个国家设有24家工厂，产品销往全球160多个国家和地区。公司主要从事消费用轮胎（包括轿车和SUV轮胎、摩托车轮胎、自行车轮胎等）、工业用轮胎（包括卡客车轮胎、工程机械轮胎、农用车轮胎等）和橡胶输送带等产品的研发、生产、销售和服务。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司控股意大利米兰证券交易所上市的倍耐力股份有限公司（PIRC.MI）和中国上海证券交易所上市的风神轮胎股份有限公司（600649.SH）两家上市公司，并控股或拥有Prometeon Tyre Group S.R.L.(简称PTG，总部位于意大利)和青岛橡六输送带有限公司等下属企业。倍耐力是全球领先的高端消费用轮胎企业；PTG是国际知名工业用轮胎企业；风神轮胎是中国领先的工业用轮胎企业；青岛橡六是中国领先的高强力橡胶输送带企业。'

    },
    {
        title: '克劳斯玛菲股份有限公司',
        img_url: pic_10,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F775`,
        content: '克劳斯玛菲股份有限公司(证券代码600579)是中国中化旗下A股上市公司。主营业务为塑料机械、橡胶机械和化工装备，产品和服务广泛应用于化工、石油化工、冶金、电力、煤炭、建筑、轻工纺织、医疗、交通、电子电气、环保等不同领域。公司历史悠久，技术底蕴深厚，目前拥有2个国家级研究中心、1个国家认定企业技术中心、1个博士后科研工作站，并在海内外多地设有技术研发中心。公司致力于建设成为世界一流的新材料及化工装备综合服务商，为全球客户提供全面的产品、技术和系统服务方案。'

    },
    {
        title: '中化环境控股有限公司',
        img_url: pic_11,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F65`,
        content: '中化环境控股有限公司是中国中化发展环境科学的专业公司，致力于成为在化工环保领域全球领先的环境服务商。中化环境坚持以核心技术为支撑的生态环境系统治理理念，发挥公司深耕化工及矿山行业的底蕴和技术优势，以“降碳、减污、扩绿、增长”为导向，构建绿色工业循环、绿色农业循环。公司聚焦盐碱地综合治理、无废集团建设、水循环三大业务，涵盖水务、废弃物处置及资源化、环境修复、大气治理、服务咨询领域，提供从咨询、设计到建设、运营一体化的智慧化综合解决方案。'

    },
    {
        title: '中国金茂控股集团有限公司',
        img_url: pic_13,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F55`,
        content: '中国金茂控股集团有限公司（简称中国金茂）是中国中化控股有限责任公司旗下城市运营领域的平台企业。中国金茂于2007年在香港联交所主板上市，中国金茂以“释放城市未来生命力”为己任，始终坚持城市运营商定位，持续推进“一核•三聚焦”业务战略升级，构建形成了以高品质开发为核心，聚焦精品持有和高端服务业务，聚焦建筑科技创新业务的多维业务联动，加速打造第二增长曲线。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;基于对城市潜能的远见，中国金茂整合国际领先的优质资源，引进合理互生的城市规划理念，实现区域功能和城市活力的全面提升。此外，公司充分发挥板块间协同效应和联动优势，打造了以“金茂”品牌为核心的高端系列产品。'

    },
    {
        title: '中化资本有限公司',
        img_url: pic_14,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F2`,
        content: '中国中化金融业务起步于1991年，业务涵盖信托、融资租赁、财务公司、公募基金、人寿保险、产业基金、商业保理、保险经纪、期货、综合商务服务、金融科技等领域。经过30余年稳健经营和创新发展，形成了资质齐备的金融业务组合，培育出“中国外贸信托”、“远东宏信”、“中宏保险”、“诺安基金”、“中化商务”等在行业内具有较强竞争力和影响力的品牌，整体风险控制能力和盈利能力均位于行业前列。'

    },
    {
        title: '中化香港（集团）有限公司',
        img_url: pic_15,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1385`,
        content: '中化香港（集团）有限公司（简称中化香港集团）于1989年在香港注册成立，注册资本244.68亿港币，由中国中化控股有限责任公司（简称中国中化）间接持有100%股权。中化香港是中国中化的二级直管单位，公司定位为中国中化的境外投融资控股平台，承担境外股权投资、境外融资、全球资金集中管理和资产管理的职责。其下控股公司主要包括中国金茂控股有限公司（HK.00817），中化欧洲集团公司、中化亚洲集团公司、中化香港石油国际有限公司和中化海外贸易有限公司等。'
    },
    {
        title: '沈阳化工研究院有限公司',
        img_url: pic_16,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F53`,
        content: '沈阳化工研究院有限公司(简称沈阳院，英文简称SYRICI）始建于1949年1月8日，是我国创立最早的综合性化工科研院所之一。1999年5月，经国务院有关部委批准，由事业单位转制为中央直属大型科技企业。2007年4月，沈阳院与中国中化集团公司重组，成为其全资子公司。现为中国中化控股有限责任公司直管单位。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目前沈阳院主要开展化工新材料、生态农业、生物化工、化学品测试与评价、化工反应风险评估、危险废物鉴别等方向的研究及产业化。'

    },
    {
        title: '中蓝晨光化工研究设计院有限公司',
        img_url: pic_17,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1299`,
        content: '中蓝晨光化工研究设计院有限公司（简称“中蓝晨光院”）为中国中化直管单位，是中国中化高端材料研究中心和多个国家级技术机构的依托单位，位于四川省成都市。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中蓝晨光院主要从事有机硅及特种氟材料、改性塑料及助剂、特种有机纤维、特种环氧树脂等化工新材料科研生产，工程化研究及EPC、分析测试、科技信息服务。是国家高新技术企业、科技创新示范企业、专精特新“小巨人”企业，科研实力和技术水平处于国内先进水平，具备较高国际知名度。'

    },
    {
        title: '中化集团财务有限责任公司',
        img_url: pic_18,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F62`,
        content: '中化集团财务有限责任公司是经中国银保监会批准设立的非银行金融机构，注册资本60亿元。财务公司坚定落实总部战略要求，在明确“辅助管理、金融服务”两个属性基础上，扎实推动“资金归集、资金结算、资金监控、金融服务”四个平台功能建设，全力打造中国中化全球一体化司库管理体系，以集团整体利益最大化为目标，服务集团战略、助力主业发展。财务公司视人力资源为第一资源，重点围绕“多渠道招聘、系统化培养、全方位激励”等开展工作，努力打造结构合理、规模适度、能力匹配的人才队伍。'

    },
    {
        title: '中化资产管理有限公司',
        img_url: pic_19,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F61`,
        content: '中化资产依托中国中化强大的产业背景，深耕企业不良资产经营处置领域，在问题企业救助、产业咨询、资产处置等方面积攒了丰富的经验。在中国经济结构转型升级、金融回归服务实体经济的大背景下，中化资产聚焦企业、金融机构和政府三类客户需求，致力于用“实现社会价值最大化”新理念引领资产管理行业发展，整合强大的央企产业、金融、管理资源，提供六种专业服务，连接产业和金融，帮助实体企业脱困转型，助力金融机构消解不良资产，协助地方政府引导经济社会实现新旧动能转换。'

    },
    {
        title: '中国化工信息中心有限公司',
        img_url: pic_20,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1324`,
        content: '中国化信系国家级行业信息研究机构，经过60多年的发展，中国化信继承和发扬在信息资源、专家团队等资源优势，跟踪国内、外化工发展趋势，面向国内外客户，提供产业规划、专业园区规划、投资机会分析、市场调研、专利查新、HSE咨询、双碳咨询、竞争情报、标准修制订等服务，已成为全国化工行业知名的信息咨询和信息服务机构。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国化信围绕“为国家建言献策，为集团谋篇布局，为行业洞察赋能”的战略目标，努力打造全球领先的化工行业新型高端智库。'

    },
    {
        title: '中化信息技术有限公司',
        img_url: pic_21,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F5`,
        content: '中化信息技术有限公司（简称“中化信息”）成立于2017年，是世界500强企业中国中化控股有限责任公司的直属数字科技公司。总部设在北京，公司自有员工330余人,常驻外部顾问330余人，97%的员工具有本科及以上学历，64%的员工毕业于985、211及海外优秀院校，是一支年轻化、高学历、高素质、强战斗力的专业人才队伍。中化信息依托于中国中化的数字化转型实践，建立起从咨询、设计到研发、交付及运维的服务价值链。秉承“客户为先、奋斗为本”优良传统，将持续以前瞻的思维，瞄准国内外领先技术，打造更多先进的产品及解决方案，与客户携手前行，共赴数字浪潮！'

    }
]